import React, { useEffect } from 'react'
import { Link, NavLink } from 'react-router-dom'
import WOW from 'wowjs'
import Cookies from 'universal-cookie'
import OwlCarousel from 'react-owl-carousel'
import Header from 'layouts/components/HeaderHome'
import 'react-loading-skeleton/dist/skeleton.css'
import bgCircle from 'assets/images/icons/about-circle.png'
import { VideoContentBox, BlogContentBox, SkeletonContentBox } from 'components/ContentBox'
import { mediaContent } from 'interface'
import { apiInstance } from 'configuration/axios'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import { useRecoilState } from 'recoil'
import { useAuth } from 'hooks/useAuth'

interface HomeContents {
  infoGraphic: mediaContent[]
  video: mediaContent[]
  newsUpdate: mediaContent[]
}

const Home = () => {
  const cookies = new Cookies()
  const { isLogin } = useAuth()
  const owlOption = {
    loop: true,
    margin: 0,
    nav: true,
    smartSpeed: 500,
    autoplay: false,
    navText: ['<span class="fa fa-angle-left"></span>', '<span class="fa fa-angle-right"></span>'],
    responsive: {
      0: {
        items: 1,
      },
      480: {
        items: 1,
      },
      600: {
        items: 1,
      },
      800: {
        items: 5,
      },
      1024: {
        items: 5,
      },
    },
  }
  const [content, setContent] = React.useState<HomeContents>({
    infoGraphic: [],
    video: [],
    newsUpdate: [],
  })
  const [homeSetting,setHomeSetting] =  React.useState<any>({
    mainBanner: {},
    popupBanner: null,
    serviceBanner: {},
  })
  const isHasBeenShowBanner = cookies.get('bannerEvent2') ? true : false
  cookies.set('bannerEvent2', 'show', {
    path: '/',
    expires: new Date(Date.now() + 1000 * 60 * 60 * 24),
  })

  // const [modal, setModal] = React.useState(!isHasBeenShowBanner);
  const [modal, setModal] = React.useState(false)
  const [isLoading, setIsLoading] = React.useState(true)

  const toggle = () => {
    setModal(!modal)
    localStorage.setItem('modalEvent', 'true')
  }

  useEffect(() => {
   
    new WOW.WOW({
      live: false,
    }).init()
  }, [])

  useEffect(() => {
    let newContent = content
    let newHomeSetting = homeSetting;

    const call1 = apiInstance.get(`home/infoGraphic`).then(res => {
      newContent = { ...newContent, infoGraphic: res.data }
    })
    const call2 = apiInstance.get(`home/newsUpdate`).then(res => {
      newContent = { ...newContent, newsUpdate: res.data }
    })
    const call3 = apiInstance.get(`home/video`).then(res => {
      newContent = { ...newContent, video: res.data }
    })
    const call4 = apiInstance.get(`home`).then(res => {
      if(res.data.PopupBanner && res.data.PopupBanner.active==='yes'){
        newHomeSetting = {...newHomeSetting,popupBanner:res.data.PopupBanner};
        setModal(true)
      }
      newHomeSetting = {...newHomeSetting,mainBanner:res.data.mainBanner};
      newHomeSetting = {...newHomeSetting,serviceBanner:res.data.serviceBanner};
      
    })
    
    Promise.all([call1, call2, call3,call4]).then(values => {
      setContent(newContent)
      setHomeSetting(newHomeSetting);
      setIsLoading(false)
      // console.log(newContent)
    })
  }, [])

  return (
    <>
    <Header banner={homeSetting.mainBanner} />
    <div className="page-wrapper">
      <section className="update-section">
        <div className="auto-container">
          <div className="sec-title mb-75">
            <h2>อย. บริการประชาชน</h2>
          </div>
          <div className="row clearfix">
            {homeSetting.serviceBanner.desktop_1 && (
            <div className="team-block-two col-lg-4 col-md-6 col-sm-12">
              <div className="inner-box">
                <div className="inner-box2">
                  <div className="image">
                    <a target="_blank" rel="noreferrer" href={homeSetting.serviceBanner.link_1 ?? ''}>
                      <img src={`${process.env.REACT_APP_MEDIA_ENDPOINT}/${homeSetting.serviceBanner.desktop_1}`} alt="" />
                    </a>
                  </div>
                  <div className="lower-content">
                    <h3>
                      <a target="_blank" rel="noreferrer" href={homeSetting.serviceBanner.link_1 ?? ''}>{homeSetting.serviceBanner.title_1 ?? ''}</a>
                    </h3>
                  </div>
                </div>
              </div>
            </div>
            )}
            {homeSetting.serviceBanner.desktop_2 && (
            <div className="team-block-two col-lg-4 col-md-6 col-sm-12">
              <div className="inner-box">
                <div className="inner-box2">
                  <div className="image">
                    <a target="_blank" rel="noreferrer" href={homeSetting.serviceBanner.link_2 ?? ''}>
                      <img src={`${process.env.REACT_APP_MEDIA_ENDPOINT}/${homeSetting.serviceBanner.desktop_2}`} alt="" />
                    </a>
                  </div>
                  <div className="lower-content">
                    <h3>
                      <a target="_blank" rel="noreferrer" href={homeSetting.serviceBanner.link_2 ?? ''}>{homeSetting.serviceBanner.title_2 ?? ''}</a>
                    </h3>
                  </div>
                </div>
              </div>
            </div>
            )}
            {homeSetting.serviceBanner.desktop_3 && (
            <div className="team-block-two col-lg-4 col-md-6 col-sm-12">
              <div className="inner-box">
                <div className="inner-box2">
                  <div className="image">
                    <a target="_blank" rel="noreferrer" href={homeSetting.serviceBanner.link_3 ?? ''}>
                      <img src={`${process.env.REACT_APP_MEDIA_ENDPOINT}/${homeSetting.serviceBanner.desktop_3}`} alt="" />
                    </a>
                  </div>
                  <div className="lower-content">
                    <h3>
                      <a target="_blank" rel="noreferrer" href={homeSetting.serviceBanner.link_3 ?? ''}>{homeSetting.serviceBanner.title_3 ?? ''}</a>
                    </h3>
                  </div>
                </div>
              </div>
            </div>
            )}
          </div>
        </div>
      </section>

      <section className="testimonial-section">
        <div className="circle-layer" style={{ backgroundImage: `url(${bgCircle})` }}></div>
        <div className="auto-container">
          {!isLoading && (
          <OwlCarousel key={`header_banner_desktop_${Date.now()}`} className="owl-theme" items={5} {...owlOption}>

          {homeSetting.serviceBanner.desktop_4 && (
            <div className="testimonial-block">
              <div className="inner-box">
                <div className="author-image-outer">
                  <div className="author-image">
                    <a href={homeSetting.serviceBanner.link_4 ?? ''} target="_blank" rel="noreferrer">
                      <img src={`${process.env.REACT_APP_MEDIA_ENDPOINT}/${homeSetting.serviceBanner.desktop_4}`} alt="" />
                      <div className="text">{homeSetting.serviceBanner.title_4 ?? ''}</div>
                    </a>
                  </div>
                </div>
              </div>
            </div>)}

            {homeSetting.serviceBanner.desktop_5 && (
            <div className="testimonial-block">
              <div className="inner-box">
                <div className="author-image-outer">
                  <div className="author-image">
                    <a href={homeSetting.serviceBanner.link_5 ?? ''} target="_blank" rel="noreferrer">
                      <img src={`${process.env.REACT_APP_MEDIA_ENDPOINT}/${homeSetting.serviceBanner.desktop_5}`} alt="" />
                      <div className="text">{homeSetting.serviceBanner.title_5 ?? ''}</div>
                    </a>
                  </div>
                </div>
              </div>
            </div>)}

            {homeSetting.serviceBanner.desktop_6 && (
            <div className="testimonial-block">
              <div className="inner-box">
                <div className="author-image-outer">
                  <div className="author-image">
                    <a href={homeSetting.serviceBanner.link_6 ?? ''} target="_blank" rel="noreferrer">
                      <img src={`${process.env.REACT_APP_MEDIA_ENDPOINT}/${homeSetting.serviceBanner.desktop_6}`} alt="" />
                      <div className="text">{homeSetting.serviceBanner.title_6 ?? ''}</div>
                    </a>
                  </div>
                </div>
              </div>
            </div>)}

            {homeSetting.serviceBanner.desktop_7 && (
            <div className="testimonial-block">
              <div className="inner-box">
                <div className="author-image-outer">
                  <div className="author-image">
                    <a href={homeSetting.serviceBanner.link_7 ?? ''} target="_blank" rel="noreferrer">
                      <img src={`${process.env.REACT_APP_MEDIA_ENDPOINT}/${homeSetting.serviceBanner.desktop_7}`} alt="" />
                      <div className="text">{homeSetting.serviceBanner.title_7 ?? ''}</div>
                    </a>
                  </div>
                </div>
              </div>
            </div>)}

            {homeSetting.serviceBanner.desktop_8 && (
            <div className="testimonial-block">
              <div className="inner-box">
                <div className="author-image-outer">
                  <div className="author-image">
                    <a href={homeSetting.serviceBanner.link_8 ?? ''} target="_blank" rel="noreferrer">
                      <img src={`${process.env.REACT_APP_MEDIA_ENDPOINT}/${homeSetting.serviceBanner.desktop_8}`} alt="" />
                      <div className="text">{homeSetting.serviceBanner.title_8 ?? ''}</div>
                    </a>
                  </div>
                </div>
              </div>
            </div>)}
          </OwlCarousel>
          )}
        </div>
      </section>
      {isLogin && (
        <section className="news-section">
          <div className="auto-container">
            <div className="sec-title">
              <div className="clearfix">
                <div className="pull-left">
                  <h2>สวัสดีคุณ <span style={{color:'#74aa42'}}>User name</span><br/>บทความและข่าวสำหรับคุณ</h2>
                </div>
                <div className="pull-right">
                  <Link to="your-page" className="theme-btn btn-style-show_all text-center">
                    <span className="txt">ดูทั้งหมด</span>
                  </Link>
                </div>
              </div>
            </div>

            <div id="wrap-home-video" className="row clearfix">
              {isLoading && (
                <>
                  <SkeletonContentBox />
                  <SkeletonContentBox />
                  <SkeletonContentBox />
                </>
              )}
              {content.video.map((content, index) => (
                <BlogContentBox
                  key={`video-${index}`}
                  page="video"
                  content={content}
                  className="news-block style-two col-lg-4 col-md-6 col-sm-12"
                />
              ))}
            </div>
          </div>
        </section>
      )}

      <section className="news-section">
        <div className="auto-container">
          <div className="sec-title">
            <div className="clearfix">
              <div className="pull-left">
                <h2>วิดีโอแนะนำ</h2>
              </div>
              <div className="pull-right">
              <Link to="vdo-recommend" className="theme-btn btn-style-show_all text-center">
                  <span className="txt">ดูทั้งหมด</span>
                </Link>
              </div>
            </div>
          </div>

          <div id="wrap-home-video" className="row clearfix">
            {isLoading && (
              <>
                <SkeletonContentBox />
                <SkeletonContentBox />
                <SkeletonContentBox />
              </>
            )}
            {content.video.map((content, index) => (
              <VideoContentBox
                key={`video-${index}`}
                page="video"
                content={content}
                className="news-block style-two col-lg-4 col-md-6 col-sm-12"
                linkDetail={`/vdo-recommend/${content._table_name}/${content.id}`}
              />
            ))}
          </div>
        </div>
      </section>

      <section className="news-section-two style-two">
        <div
          className="pattern-layer-two"
          style={{
            backgroundImage: `url(assets/images/background/pattern-24.png)`,
          }}></div>
        <div
          className="pattern-layer-custom"
          style={{
            backgroundImage: `url(assets/images/background/pattern-20.png)`,
          }}></div>
        <div className="auto-container">
          <div className="sec-title">
            <div className="clearfix">
              <div className="pull-left">
                <h2>อินโฟกราฟิกล่าสุด</h2>
              </div>
              <div className="pull-right">
                <Link to="media/infoGraphic" className="theme-btn btn-style-show_all text-center">
                  <span className="txt">ดูทั้งหมด</span>
                </Link>
              </div>
            </div>
          </div>

          <div id="wrap-home-infographic" className="row clearfix">
            {isLoading && (
              <>
                <SkeletonContentBox />
                <SkeletonContentBox />
                <SkeletonContentBox />
              </>
            )}
            {content.infoGraphic.map((content, index) => (
              <BlogContentBox
                key={`infographic-${index}`}
                page="infoGraphic"
                content={content}
                className="news-block-two style-two col-lg-4 col-md-6 col-sm-12 max-height-pic-195"
              />
            ))}
          </div>
        </div>
      </section>
      <section className="news-section">
        <div className="auto-container">
          <div className="sec-title">
            <div className="clearfix">
              <div className="pull-left">
                <h2>ข่าวล่าสุด</h2>
              </div>
              <div className="pull-right">
                <Link to="media/newsUpdate" className="theme-btn btn-style-show_all text-center">
                  <span className="txt">ดูทั้งหมด</span>
                </Link>
              </div>
            </div>
          </div>

          <div id="wrap-home-newsupdate" className="row clearfix">
            {isLoading && (
              <>
                <SkeletonContentBox />
                <SkeletonContentBox />
                <SkeletonContentBox />
              </>
            )}
            {content.newsUpdate.map((content, index) => (
              <BlogContentBox
                key={`newsUpdate-${index}`}
                page="newsUpdate"
                content={content}
                className="news-block style-two col-lg-4 col-md-6 col-sm-12 max-height-pic-195"
              />
            ))}
          </div>
        </div>
      </section>
      <div>
        {homeSetting.popupBanner && homeSetting.popupBanner.desktop && (
        <Modal className="modal-event" isOpen={modal} toggle={toggle}>
          <ModalHeader toggle={toggle}></ModalHeader>
          <ModalBody>
            <a href={homeSetting.popupBanner.link ?? '#'} target={`_blank`}>
              <img
                src={`${process.env.REACT_APP_MEDIA_ENDPOINT}/${homeSetting.popupBanner.desktop}`}
                alt=""
              />
            </a>
          </ModalBody>
          {/* <ModalFooter>
          <Button color="primary" onClick={toggle}>Do Something</Button>{' '}
          <Button color="secondary" onClick={toggle}>Cancel</Button>
        </ModalFooter> */}
        </Modal>)}
      </div>
    </div>
    </>
  )
}
export default Home
